<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        //- i.fa.fa-chevron-left.sr-only
        i
        span Confirmatory
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      p.card-text In conformity with the implementing Rules and Regulations of R.A. 10173, known as the "Data Privacy Act of 2012", that seeks to protect all forms of information, be it private, personal or sensitive. I give my consent the use and collection of my personal data by answering the form
      ValidationObserver(ref="Validation" slim)
        ValidationProvider(name="confirmatory" rules="required" v-slot="{error}" slim)
          .custom-control.custom-checkbox
            input.custom-control-input#confirmatory(type="checkbox")
            label.custom-control-label(for="confirmatory") I understand that my personal information is protected by RA 10173, the Data Privacy Act of 2012, and that I am required to provide truthful and correct information.
</template>

<style scoped=""></style>

<script>
  import { ref, reactive } from '@vue/composition-api'

  export default {
    name: 'step_1',
    props: {
      // config: {
      //   type: Object,
      //   required: true
      // }
    },
    emits: ['next'],

    setup(props, {emit}) {
      const Validation = ref(null)

      const next = () => {
        emit('next')
      }
      return {
        Validation,
        next
      }
    }
  }
</script>